import immerHandleActions from 'redux/utils/immerHandleActions';

import * as actions from './actions';
import { UserProfile } from 'utils/api/models/users/userProfile';

interface state extends types.redux.api.session.state {}
interface setLoginAction extends types.redux.api.session.setLoginAction {}
interface setLoginErrorAction extends types.redux.api.session.setLoginErrorAction {}

export const initialState = (): state => ({
	isLoginSuccessful: true,
	authenticated: false,
	authorized: false,
	isAuthenticating: false,
	showWelcomeModal: false,
	isWeakPassword: false,
	login: '',
	isOTPModalOpen: false,
	isValidatingOTP: false,
	isWrongOTP: false,
	errorMessage: '',
	errorCode: '',
	user: {
		email: '',
		accountName: '',
		upId: '',
		userId: '',
		userName: '',
		userType: '',
		accountPermissions: [],
		departmentPermissions: [],
		contactNumber1: '',
		nmfloId: null,
	},
});

const reducer = {
	[actions.setLoginSuccessful]: (state: any) => ({
		...state,
		isLoginSuccessful: true,
		authenticated: true,
		authorized: true,
		errorMessage: '',
		errorCode: '',
		isWeakPassword: false,
		isOTPModalOpen: false,
	}),
	[actions.setLoginUnsuccessful]: (state: state) => ({
		...state,
		isLoginSuccessful: false,
		isWeakPassword: false,
		errorMessage: '',
		errorCode: 'LOGIN_FAILED',
	}),
	[actions.setLoginReset]: (state: state) => ({
		...state,
		errorMessage: '',
		errorCode: '',
		isWeakPassword: false,
		isOTPModalOpen: false,
		isLoginSuccessful: true,
	}),
	[actions.setIsAuthenticating]: (state: state, action: { payload: boolean }) => ({
		...state,
		isAuthenticating: action.payload,
	}),
	[actions.setLogin]: (state: state, action: { payload: setLoginAction }) => ({
		...state,
		login: action.payload.login,
	}),
	[actions.setOTPModalOpen]: (state: state, action: { payload: boolean }) => {
		if (action.payload) {
			return {
				...state,
				isOTPModalOpen: action.payload,
			};
		}
		return {
			...state,
			isOTPModalOpen: action.payload,
			errorCode: '',
			errorMessage: '',
		};
	},
	[actions.setOTPWrong]: (state: state, action: { payload: boolean }) => ({
		...state,
		isWrongOTP: action.payload,
	}),
	[actions.setIsOTPValidation]: (state: state, action: { payload: boolean }) => ({
		...state,
		isValidatingOTP: action.payload,
	}),
	[actions.setErrorMessage]: (state: state, action: { payload: setLoginErrorAction }) => ({
		...state,
		errorMessage: action.payload.errorMessage,
		errorCode: action.payload.errorCode,
	}),
	[actions.setUserProfileData]: (state: state, action: { payload: UserProfile }) => ({
		...state,
		user: {
			...state.user,
			email: action.payload.email || initialState().user.email,
			accountName: action.payload.accountName,
			upId: action.payload.upId,
			userId: action.payload.userId,
			userName: action.payload.userName,
			userType: action.payload.userType,
			departmentPermissions: action.payload.departmentPermissions,
			accountPermissions: action.payload.accountPermissions,
			contactNumber1: action.payload.contactNumber1,
		},
	}),
	[actions.setNmfloId]: (state: state, action: { payload: UserProfile }) => ({
		...state,
		user: {
			...state.user,
			nmfloId: action.payload,
		},
	}),
	[actions.logOut]: () => initialState(),
	[actions.lockScreen]: (state: state) => ({
		...state,
		authenticated: false,
		isWeakPassword: false,
	}),
	[actions.redirectUnauthorized]: (state: state) => ({
		...state,
		authorized: false,
		isWeakPassword: false,
	}),
	[actions.setIsWeakPassword]: (state: state, action: { payload: boolean }) => ({
		...state,
		isWeakPassword: action.payload,
	}),
	[actions.setShowWelcomeModal.toString()]: (state: state, action: { payload: boolean }) => ({
		...state,
		showWelcomeModal: action.payload,
	}),
	'persist/REHYDRATE': (state: state, { payload = {} }) => {
		// @ts-ignore
		const { session } = payload;
		const { authenticated, user, login, authorized, showWelcomeModal, isWeakPassword } = session || initialState();
		return {
			...initialState(),
			...state,
			isWeakPassword,
			login,
			authorized,
			authenticated,
			showWelcomeModal,
			user,
		};
	},
};

export default immerHandleActions(reducer, initialState());
